import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { graphQL } from 'javascripts/shared/graphql';
import { graphQLMutations } from 'javascripts/shared/graphql/mutations';

import { FollowButton } from 'javascripts/components/follow_button';

const FOLLOWING_ERROR_ACTION = 'following';
const UNFOLLOWING_ERROR_ACTION = 'unfollowing';

export function TagFollowButton({
  onError,
  onFollowChange,
  tag: { id: tagId, followedByCurrentUser },
  trackingCategory,
}) {
  const [isFollowing, setIsFollowing] = useState(followedByCurrentUser);

  useEffect(() => setIsFollowing(followedByCurrentUser), [followedByCurrentUser]);

  function trackClick() {
    if (_.isNil(trackingCategory)) {
      return;
    }

    bubEvents.track(trackingCategory, 'Clicked button', {
      label: 'Tag follow status',
      value: isFollowing ? 'Unfollow' : 'Follow',
      tag_id: tagId,
    });
  }

  function onClick() {
    trackClick();

    if (isFollowing) {
      graphQL
        .get(graphQLMutations.unfollowTag, { tagId })
        .then(() => {
          setIsFollowing(false);
          onFollowChange();
        })
        .catch(() => {
          onError(UNFOLLOWING_ERROR_ACTION);
        });
    } else {
      graphQL
        .get(graphQLMutations.followTag, { tagId })
        .then(() => {
          setIsFollowing(true);
          onFollowChange();
        })
        .catch(() => {
          onError(FOLLOWING_ERROR_ACTION);
        });
    }
  }

  return <FollowButton isFollowing={isFollowing} onClick={onClick} />;
}

TagFollowButton.propTypes = {
  onError: PropTypes.func,
  onFollowChange: PropTypes.func,
  tag: PropTypes.shape({
    id: PropTypes.string.isRequired,
    followedByCurrentUser: PropTypes.bool,
  }).isRequired,
  trackingCategory: PropTypes.string,
};

TagFollowButton.defaultProps = {
  onError: _.noop,
  onFollowChange: _.noop,
};
